"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoverageCardEnabledList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var svgs_1 = require("../assets/svgs");
var Icon = function (_a) {
    var type = _a.type;
    var iconComponent = (0, jsx_runtime_1.jsx)(svgs_1.Check, {});
    var backgroundColor = 'primary.300';
    switch (type) {
        case 'success':
            backgroundColor = 'success.main';
            break;
        case 'error':
            iconComponent = (0, jsx_runtime_1.jsx)(svgs_1.Union, {});
            backgroundColor = 'error.main';
            break;
        default:
            break;
    }
    var sx = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '2.0rem',
        height: '2.0rem',
        borderRadius: '9999px',
        backgroundColor: backgroundColor,
        color: 'primary.600',
    };
    return ((0, jsx_runtime_1.jsx)(material_1.ListItemIcon, __assign({ sx: { minWidth: '2.8rem', paddingTop: '4px' } }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ component: "span", sx: sx }, { children: iconComponent })) })));
};
var Item = function (_a) {
    var text = _a.text, type = _a.type, index = _a.index;
    return ((0, jsx_runtime_1.jsxs)(material_1.ListItem, __assign({ disableGutters: true, sx: { paddingY: '0.6rem', alignItems: 'start' } }, { children: [(0, jsx_runtime_1.jsx)(Icon, { type: type }), (0, jsx_runtime_1.jsx)(material_1.ListItemText, { primary: text })] }), index));
};
var CoverageCardEnabledList = function (_a) {
    var data = _a.data, _b = _a.name, name = _b === void 0 ? '' : _b, sx = _a.sx;
    return ((0, jsx_runtime_1.jsx)(material_1.List, __assign({ sx: __assign({}, sx) }, { children: data.map(function (item, index) {
            return ((0, jsx_runtime_1.jsx)(Item, { index: "".concat(index, "-").concat(name), text: item.text, type: item.type }, "".concat(index, "-").concat(name)));
        }) })));
};
exports.CoverageCardEnabledList = CoverageCardEnabledList;
